// extracted by mini-css-extract-plugin
export default {"modalStyle":"CreateCollection_modalStyle__8-T4g","buttonBox":"CreateCollection_buttonBox__1C5Ms","buttonStyles":"CreateCollection_buttonStyles__ykF5E"};